import {ToastContainer} from "react-toastify";
import {createElement} from 'react';
import {useUiTheme} from 'theme/useUiTheme';

export default function ThemedToastContainer(props) {
    const {mode} = useUiTheme();
    return createElement(ToastContainer, {...props, theme: mode});
}
